module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--12.42f9bf3d.svg";